import { render, staticRenderFns } from "./AccidentDelivery.vue?vue&type=template&id=4ec1bb9c"
import script from "./AccidentDelivery.vue?vue&type=script&lang=js"
export * from "./AccidentDelivery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports